import t from"react";import{mdiFileExportOutline as e}from"@mdi/js";import{MdIcon as o}from"./MdIcon.js";const r=({id:r="file-export",title:i="File export",...m})=>t.createElement(o,{id:r,title:i,path:e,...m});export{r as FileExportIcon};
